import React from 'react';
import PropTypes from 'prop-types';

import { wrapperStyle, inputStyle, submitStyle, labelStyle } from './styles';

class SingleFieldFormComponent extends React.PureComponent {
	state = {
		value: '',
	};

	onChange = e => {
		this.setState({ value: e.target.value });
		if (this.props.onChange) this.props.onChange(e);
	};

	onSubmit = e => {
		this.props.onSubmit(e, this.state.value);
	};

	render() {
		const {
			placeholderText,
			label,
			buttonContent,
			inputId,
			inputName,
			inputWidth,
			initialValue,
			value,
			onChange,
			netlify,
			name,
		} = this.props;
		const id = inputId || 'single-field-form-element-' + Math.random() * 99999;

		const netlifyHoneypot = netlify ? 'botField' : undefined;

		return (
			<form
				name={name}
				onSubmit={this.onSubmit}
				data-component="SingleFieldForm"
				netlify={netlify ? 'true' : undefined}
				netlify-honeypot={netlifyHoneypot}
			>
				<div className={wrapperStyle}>
					{label && (
						<label className={labelStyle} htmlFor={id}>
							{label}
						</label>
					)}
					{netlify && <input style={{ display: 'none' }} name={netlifyHoneypot} />}
					<input
						id={id}
						name={inputName}
						className={inputStyle(inputWidth)}
						placeholder={placeholderText}
						defaultValue={initialValue}
						onChange={onChange || this.onChange}
						value={value || this.state.value}
					/>
					<button className={submitStyle(typeof buttonContent === 'string')}>
						{buttonContent}
					</button>
				</div>
			</form>
		);
	}
}

SingleFieldFormComponent.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	placeholderText: PropTypes.string,
	inputWidth: PropTypes.number,
	inputName: PropTypes.string,
	label: PropTypes.string,
	buttonContent: PropTypes.any,
	inputId: PropTypes.string,
	value: PropTypes.string,
	initialValue: PropTypes.string,
	onChange: PropTypes.func,
	name: PropTypes.string,
	netlify: PropTypes.bool,
};

export const SingleFieldForm = SingleFieldFormComponent;



// WEBPACK FOOTER //
// ./src/components/shared/singleFieldForm/component.js